<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-dialog
        v-model="dialogRemove"
        persistent :overlay="false"
        transition="dialog-transition"
        max-width="600px"
        v-if="dialogRemove"
      >
        <v-card class="pa-0">
          <v-card-text class="text-xs-center">
            <h3 class="mt-5 mb-3">Opravu chcete stornovat tuto objednávku?</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" @click="remove" :loading="removing" dark depressed>Stornovat objednávku</v-btn>
            <v-btn color="grey" flat @click="dialogRemove=false" v-if="!removing">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <h2 class="mt-2">Objednávka č. {{ objednavka.cislo_objednavky }}</h2>

            <v-layout row wrap v-if="objednavka.stav=='zruseno'" class="mb-4">
              <v-flex xs12>
                <h3 class="red--text">Zrušená objednávka</h3>
              </v-flex>
            </v-layout>

            <h4 class="mt-4">Seznam objednaných produktů:</h4>
            <div class="table-border__radius elevation-1 mt-2">

              <v-layout row wrap>
                <v-flex xs12>
                  <v-form lazy-validation v-model="valid" ref="form">
                    <v-data-table
                      :headers="produktyHeaders"
                      :items="objednavka.produkty"
                      hide-actions
                      class="mt-2"
                    >
                      <template slot="items" slot-scope="props">
                        <td class="subheading">
                          <router-link :to="{ path: '/produkty/' + props.item.id }" target="_blank" v-if="props.item.typ=='produkt'">
                            {{ props.item.produkt.nazev }}
                          </router-link>
                          <span v-else><span v-if="!objednavka.dodavatel.metal_konto">Interní </span>Metal konto - {{ props.item.material.nazev }}</span>
                        </td>
                        <td class="text-xs-right subheading">
                          <v-text-field
                            v-if="editMode"
                            label="Množství"
                            v-model="props.item.mnozstvi"
                            :suffix="props.item.typ=='produkt' ? 'ks' : 'g'"
                            :rules="required"
                          ></v-text-field>
                          <div v-else>
                            <span v-if="props.item.typ=='produkt'">{{ props.item.mnozstvi }} ks</span><span v-else>{{ props.item.mnozstvi | formatMoney }} g</span>
                          </div>
                        </td>
                        <td></td>

                        <v-dialog
                          v-model="dialogEmail"
                          persistent :overlay="false"
                          transition="dialog-transition"
                          max-width="600px"
                          v-if="dialogEmail"
                        >
                          <v-card class="pa-0">
                            <v-card-title primary-title class="pa-0">
                              <h3>Vygenerování objednávky do emailu</h3>
                            </v-card-title>
                            <v-card-text class="pa-0 mt-3">
                              <table style="border-collapse: collapse;width: 100%;">
                                <thead>
                                  <tr>
                                    <th style="width: 60%;border: 1px solid #dddddd;text-align: left;padding: 5px 8px;">Produkt</th>
                                    <th style="width: 40%;border: 1px solid #dddddd;text-align: left;padding: 5px 8px;">Množství</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td style="width: 60%;border: 1px solid #dddddd;text-align: left;padding: 5px 8px;">
                                      <span v-if="props.item.typ=='produkt'">
                                        {{ props.item.produkt.nazev }}
                                      </span>
                                      <span v-else>
                                        <span v-if="!objednavka.dodavatel.metal_konto">Interní </span>
                                        Metal konto - {{ props.item.material.nazev }}
                                      </span>
                                    </td>
                                    <td style="width: 40%;border: 1px solid #dddddd;text-align: left;padding: 5px 8px;">
                                      <span v-if="props.item.typ=='produkt'">{{ props.item.mnozstvi }} ks</span>
                                      <span v-else>{{ props.item.mnozstvi | formatMoney }} g</span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-card-text>
                            <v-card-actions class="pa-0 mt-4">
                              <v-spacer></v-spacer>
                              <v-btn color="primary" dark depressed>Zkopírovat do schránky</v-btn>
                              <v-btn color="grey" flat @click="dialogEmail=false">Zavřít</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>

                      </template>
                    </v-data-table>
                  </v-form>
                </v-flex>
              </v-layout>

            </div>

            <v-layout row wrap class="mt-3 pb-5" v-if="objednavka.stav!='zruseno'">
              <v-flex xs12>
                <div v-if="!editMode">
                  <a :href="api_url + 'dodavatele/objednavky/' + id + '/pdf'" target="_blank">
                    <v-btn color="primary" @click="dialogPDF=true" large depressed :class="{'v-btn--block':$vuetify.breakpoint.xs}">Uložit do PDF</v-btn>
                  </a>
                  <v-btn color="primary" @click="dialogEmail=true" large depressed :class="{'v-btn--block':$vuetify.breakpoint.xs}">Vygenerovat do emailu</v-btn>
                  <router-link :to="{ path: '/dodavatele/objednavky/' + objednavka.id + '/faktura' }" v-if="objednavka.stav!='predbezna' && !objednavka.faktura">
                    <v-btn color="primary" large depressed :class="{'v-btn--block':$vuetify.breakpoint.xs}">
                      <v-icon small class="mr-2">add</v-icon> <span v-if="!objednavka.pouze_naskladnit">Přidat fakturu</span><span v-else>Naskladnit</span>
                    </v-btn>
                  </router-link>
                  <router-link :to="{ path: '/dodavatele/objednavky/' + objednavka.id + '/faktura' }" v-else-if="objednavka.faktura">
                    <v-btn color="primary" large depressed :class="{'v-btn--block':$vuetify.breakpoint.xs}">
                      <v-icon small class="mr-2">receipt</v-icon> <span v-if="!objednavka.pouze_naskladnit">Faktura</span><span v-else>Naskladnění</span>
                    </v-btn>
                  </router-link>
                  <router-link :to="{ path: '/dodavatele/objednavky/' + objednavka.id + '/prijemky' }" v-if="objednavka.stav!='predbezna' && objednavka.faktura && !objednavka.pouze_naskladnit">
                    <v-btn color="primary" large depressed :class="{'v-btn--block':$vuetify.breakpoint.xs}">
                      <span v-if="objednavka.prijemky"><v-icon small class="mr-2">list_alt</v-icon> Příjemky</span><span v-else><v-icon small class="mr-2">add</v-icon> Vytvořit příjemku</span>
                    </v-btn>
                  </router-link>
                  <v-btn color="orange" v-if="objednavka.stav!='predbezna' && !objednavka.faktura" dark large depressed @click="editClick" :class="{'v-btn--block':$vuetify.breakpoint.xs}"><v-icon class="mr-2">edit</v-icon>Upravit objednávku</v-btn>
                  <v-btn color="red" v-if="objednavka.stav!='predbezna' && !objednavka.faktura" dark large depressed @click="removeClick" :class="{'v-btn--block':$vuetify.breakpoint.xs}"><v-icon class="mr-2">cancel</v-icon>Zrušit objednávku</v-btn>
                </div>
                <div v-else>
                  <v-btn color="orange" v-if="objednavka.stav!='predbezna' && !objednavka.faktura" dark large depressed @click="save" :loading="saving"><v-icon class="mr-2">edit</v-icon>Uložit</v-btn>
                  <v-btn color="grey lighten-3" v-if="!saving" large depressed @click="cancel">Zrušit</v-btn>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      objednavka: null,
      produktyHeaders: [
        { text: 'Produkt', value: 'cilovy_produkt', sortable: false, width: "600px" },
        { text: 'Množství', value: 'fixovane_mnozstvi', sortable: false, width: "180px", align: "right" },
        { text: '', value: '', sortable: false, align: "right" }
      ],
      editMode: false,
      required: [
        (v) => (!!v && !isNaN(v) && parseFloat(v) >= 0) || "Je třeba zadat číslo"
      ],
      dialog: false,
      dialogEmail: false,
      valid: true,
      saving: false,
      dialogRemove: false,
      removing: false
    }
  },
  computed: {
    api_url () {
      return window.api.$api_url;
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {
    produkty: {
      handler (v) {
        this.resolve();
      },
      deep: true
    }
  },
  props: {
    id: String
  },
  methods: {
    load: function(f) {
      this.loading = true;
      window.API.get("dodavatele/objednavky/" + this.$props.id).then(function(b) {
        this.objednavka = b;
        this.loading = false;
        this.editMode = false;
        if (typeof f == "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    editClick () {
      this.editMode = true;
    },
    save () {
      if (this.$refs.form.validate()) {
        this.saving = true;
        window.API.put("dodavatele/objednavky/" + this.$props.id, {
          polozky: this.objednavka.produkty.map((e) => {
            return {
              id: e.id,
              mnozstvi: e.typ == 'produkt' ? parseInt(e.mnozstvi) : parseFloat(e.mnozstvi)
            };
          })
        }).then(function(b) {
          if (b.updated)
            this.load(() => {
              this.saving = false;
              this.editMode = false;
            })
          else
            this.saving = false;
        }.bind(this)).catch(function(err) {
          this.saving = false;
          console.log(err);
        }.bind(this));
      }
    },
    cancel () {
      this.load();
    },
    removeClick () {
      this.dialogRemove = true;
    },
    remove () {
      this.removing = true;
      window.API.delete("dodavatele/objednavky/" + this.$props.id).then(function(b) {
        if (b.updated)
          this.$router.push({ path: "/dodavatele/objednavky" });
        else
          this.removing = false;
      }.bind(this)).catch(function(err) {
        this.removing = false;
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Dodavatele/DodavateleObjednavkaDetail.vue